import request from '@/utils/request'

// 查询角色信息列表分页
export function fetchList(query) {
    return request({
        url: '/system/role/default/page',
        method: 'get',
        params: query,
    })
}
// 查询角色信息列表不分页
export function roleList(query) {
    return request({
        url: '/system/role/default/list',
        method: 'get',
        params: query,
    })
}
// 查询角色详细
export function getObj(id) {
    return request({
        url: '/system/role/default/detail?id=' + id,
        method: 'get',
    })
}
// 新增角色
export function addObj(data) {
    return request({
        url: '/system/role/default/add',
        method: 'post',
        data: data,
    })
}

// 修改角色
export function putObj(data) {
    return request({
        url: '/system/role/default/edit',
        method: 'post',
        data: data,
    })
}
// 删除角色
export function delObj(data) {
    return request({
        url: '/system/role/default/delete',
        method: 'post',
        data: data,
    })
}